import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockTickerSectionFields } from './groq';

/** Shared registry entry. Lazy: not on the critical rendering path. */
export const tickerSectionBlockConfig = {
  name: 'outer-block-ticker-section',
  component: defineAsyncComponent(() => import('./CmsTickerSectionBlock.vue')),
  innerComponent: defineAsyncComponent(() => import('./OuterTicker.vue')),
  fields: blockTickerSectionFields,
} satisfies ModularBlockConfig;
